import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import { ArticleDefault, MainPageDefault, SectionDefault } from './customComponents.js'

export default class App extends Component {
  constructor (props) {
    super(props)
    this.state = {}
    const hash = window.location.hash

    if (hash) {
      let newUrl = hash.replace('#', '/')
      newUrl = newUrl.replace('-', '/')
      window.location.href = window.location.origin + '/help' + newUrl
    }
  }

  handleChangeView = (permalink, page, history) => {
    const path = page && permalink ? page + '/' + permalink : ''
    history.push('/' + path)
  }

  render () {
    const Section = (routeProps) => {
      const match = routeProps.match
      if (match.params.type === 'section' || match.params.type === 'sezione') {
        return (
          <SectionDefault {...routeProps}
            realm={this.props.params.realm}
            changeView={(permalink, page) => this.handleChangeView(permalink, page, routeProps.history)}
            className='mainpageDefault'
            isExternal
            searchKey={match.params.id}
          />
        )
      } else if (match.params.type === 'article' || match.params.type === 'articolo') {
        return (
          <ArticleDefault
            realm={this.props.params.realm}
            changeView={(permalink, page) => this.handleChangeView(permalink, page, routeProps.history)}
            searchKey={match.params.id}
            isExternal
          />
        )
      }
    }

    return (
      <Router basename='help'>
        <Switch>
          <Route path='/' exact
            render={(routeProps) => (
              <MainPageDefault {...routeProps}
                realm={this.props.params.realm}
                changeView={(permalink, page) => this.handleChangeView(permalink, page, routeProps.history)}
                className='mainpageDefault'
                isExternal
              />
            )}
          />
          <Route path={'/:type'} exact
            render={(routeProps) => {
              return <Section {...routeProps} />
            }}
          />
          <Route path={'/:type/:id'} exact
            render={(routeProps) => {
              return <Section {...routeProps} />
            }}
          />
        </Switch>
      </Router>
    )
  }
}

App.propTypes = {
  params: PropTypes.object
}



// WEBPACK FOOTER //
// ./src/help/external/js/App.js